
import Confirm from 'vux/src/components/confirm/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import vFooter from '../../common/footer.vue'
import {getMemberAsset,assetRecordList} from '@/base/js/api'
export default {
name: 'app',
data() {
return {
tabIndex:1,
data:'',
sum:'',
accessToken:this._wxTool.getAccessToken(),
listType:'all',
noMore:false,
onFetching:false,
PrmPageNo:1,
totalPage:1
}
},
components: {
Confirm,
Scroller,
LoadMore,
vFooter
},
created(){
let params ={
accessToken : this._wxTool.getAccessToken()
}
getMemberAsset(params).then(res=>{
if(res.code == 0){
console.log(res);
this.sum = res.data.asset

}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
this.getData()
},
methods: {
tab(e){
let tabIndex = e;
this.tabIndex=tabIndex;
this.PrmPageNo=1;
this.totalPage=1;
this.onFetching=false;
this.noMore = false
switch(e){
case 1 :
this.listType = 'all'
break;
case 2 :
this.listType = 'income'
break;
case 3 :
this.listType = 'putForward'
break;
}
this.getData()
},
tx(){
this.$router.push('extract')
},
onScrollBottom(){
if (this.onFetching) {

} else {
if(this.totalPage==1){
return
}
console.log(this.totalPage,this.PrmPageNo)
if(this.totalPage<=this.PrmPageNo){
this.$vux.toast.text('亲！已经到底了！', 'middle')
return
}
this.onFetching = true
let params= {
accessToken : this.accessToken,
listType:this.listType,
PrmPageNo:this.PrmPageNo+=1,
}
assetRecordList(params).then(res=>{
if(res.code == 0){
this.data = this.data.concat(res.data.memberAssetRecordList)
this.$nextTick(() => {
this.$refs.scrollerBottom.reset()
})
setTimeout(() => {
if(res.data.page.totalPage>=this.PrmPageNo){
this.onFetching = false
}
}, 2000)
if(this.data.length==0){
this.noMore = true
}
this.noMore = false
}else{
this.$vux.toast.text(res.msg, 'middle')
this.noMore = true
}
})
}
},
getData(){
let params ={
accessToken : this.accessToken,
listType:this.listType,
}
assetRecordList(params).then(res=>{
if(res.code == 0){
console.log(res);
this.data = res.data.memberAssetRecordList
this.totalPage = res.data.page.totalPage
if(!this.data[0]){
this.noMore = true
return
}
this.$nextTick(() => {
this.$refs.scrollerBottom.reset({top: 0})
})
}else{
this.$vux.toast.text(res.msg, 'middle');
this.noMore = true
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/my/extractRecord/extractRecord.vue